import React, { FC, useRef } from 'react'
import { motion, useInView } from 'framer-motion'

interface HospitalKeyFeaturesProps {
    hospitalDashData: any
}

const HospitalKeyFeatures: FC<HospitalKeyFeaturesProps> = ({ hospitalDashData }) => {
    const ref = useRef(null)
    const isInView = useInView(ref, { once: false, amount: 0.2 })

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    }

    const cardVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    }

    return (
        <motion.div 
            ref={ref}
            variants={containerVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-12 p-4 sm:p-8 lg:p-20 bg-blackDark'
        >
            {hospitalDashData.HosDashFeatureList.map((reliable: any, index: number) => {
                return (
                    <motion.div 
                        className='w-full' 
                        key={index}
                        variants={cardVariants}
                        whileHover={{ scale: 1.03 }}
                        transition={{ type: "spring", stiffness: 300, damping: 15 }}
                    >
                        <motion.div 
                            className={`bg-${reliable.color} pl-1 rounded-2xl`}
                            whileHover={{ 
                                paddingLeft: "0.25rem",
                                transition: { duration: 0.3 }
                            }}
                        >
                            <motion.div className="flex flex-col items-start justify-center p-3 sm:p-4 lg:px-8 bg-darkGreyPrimary rounded-2xl relative">
                                <div className='bg-darkGreyPrimary rounded-2xl w-full group'>
                                    <motion.div 
                                        className={`text-lg sm:text-xl text-start font-semibold text-white group-hover:text-${reliable.color}`}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ delay: 0.3 + index * 0.1 }}
                                    >
                                        {index + 1}.
                                    </motion.div>
                                    <motion.div 
                                        className={`text-lg sm:text-xl text-start font-semibold text-white mb-2 sm:mb-3 group-hover:text-${reliable.color}`}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ delay: 0.4 + index * 0.1 }}
                                    >
                                        {reliable.title}
                                    </motion.div>
                                    <motion.ul 
                                        className='list-disc flex flex-col gap-2 sm:gap-3 pl-4 sm:pl-5'
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ delay: 0.5 + index * 0.1, staggerChildren: 0.1, delayChildren: 0.7 + index * 0.1 }}
                                    >
                                        <motion.li variants={cardVariants}>
                                            <div className='text-white text-start text-sm sm:text-md font-bold'>Patient management</div>
                                            <div className='text-white text-start text-xs sm:text-sm pr-2 sm:pr-8'> {reliable.subtitle}</div>
                                        </motion.li>
                                        <motion.li variants={cardVariants}>
                                            <div className='text-white text-start text-sm sm:text-md font-bold'>Patient management</div>
                                            <div className='text-white text-start text-xs sm:text-sm pr-2 sm:pr-8'> {reliable.subtitle}</div>
                                        </motion.li>
                                        <motion.li variants={cardVariants}>
                                            <div className='text-white text-start text-sm sm:text-md font-bold'>Patient management</div>
                                            <div className='text-white text-start text-xs sm:text-sm pr-2 sm:pr-8'> {reliable.subtitle}</div>
                                        </motion.li>
                                        <motion.li variants={cardVariants}>
                                            <div className='text-white text-start text-sm sm:text-md font-bold'>Patient management</div>
                                            <div className='text-white text-start text-xs sm:text-sm pr-2 sm:pr-8'> {reliable.subtitle}</div>
                                        </motion.li>
                                    </motion.ul>
                                </div>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                )
            })}
        </motion.div>
    )
}

export default HospitalKeyFeatures
